
import React from 'react';
import ProductFormContent from './ProductFormContent';
import { UseProductFormReturn } from '../hooks/product-form/types';

interface ProductFormWrapperProps {
  productForm: UseProductFormReturn;
  shopId?: string;
  organizationId: string | null;
  defaultFormId?: string | null;
}

const ProductFormWrapper = ({ productForm, shopId, organizationId, defaultFormId }: ProductFormWrapperProps) => {
  const effectiveShopId = shopId || productForm.product?.shop_id || '';
  
  console.log('ProductFormWrapper using shop ID:', effectiveShopId);
  console.log('ProductFormWrapper using default form ID:', defaultFormId);
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="md:col-span-2 space-y-6">
        <ProductFormContent
          shopName=""
          shopId={effectiveShopId}
          organizationId={organizationId}
          name={productForm.name}
          setName={productForm.setName}
          overview={productForm.overview}
          setOverview={productForm.setOverview}
          showSummary={productForm.showSummary}
          setShowSummary={productForm.setShowSummary}
          description={productForm.description}
          setDescription={productForm.setDescription}
          benefits={productForm.benefits}
          setBenefits={productForm.setBenefits}
          faqs={productForm.faqs}
          setFaqs={productForm.setFaqs}
          mediaUrls={productForm.mediaUrls}
          previewMediaUrls={[]}
          addMediaUrl={(url) => productForm.setMediaUrls([...productForm.mediaUrls, url])}
          removeMediaUrl={(index) => {
            const newUrls = [...productForm.mediaUrls];
            newUrls.splice(index, 1);
            productForm.setMediaUrls(newUrls);
          }}
          removeExistingMediaUrl={(index) => {
            const newUrls = [...productForm.mediaUrls];
            newUrls.splice(index, 1);
            productForm.setMediaUrls(newUrls);
          }}
          productId={productForm.productId}
          price={productForm.price}
          setPrice={productForm.setPrice}
          discountPrice={productForm.discountPrice}
          setDiscountPrice={productForm.setDiscountPrice}
          currency={productForm.currency}
          setCurrency={productForm.setCurrency}
          quantity={productForm.quantity}
          setQuantity={productForm.setQuantity}
          lowStockThreshold={productForm.lowStockThreshold}
          setLowStockThreshold={productForm.setLowStockThreshold}
          isOutOfStock={productForm.isOutOfStock}
          setIsOutOfStock={productForm.setIsOutOfStock}
          sku={productForm.sku}
          setSku={productForm.setSku}
          product={productForm.product}
          formId={productForm.formId}
          setFormId={productForm.setFormId}
          defaultFormId={defaultFormId}
        />
      </div>
    </div>
  );
};

export default ProductFormWrapper;
